import { lazy, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Tool from "../../shared/components/Tool";
import { NEW_CASE_PARAM } from "../../shared/consts";
import {
  MUTATION_DELETE_GT_CASE,
  MUTATION_UPDATE_GT_CASE,
} from "../../shared/gql/mutations";
import {
  QUERY_GET_ALL_GT_CASES,
  QUERY_GET_GT_CASE,
} from "../../shared/gql/queries";
import CaseProvider from "../../shared/providers/CaseProvider";
import AddGTDialog from "../components/AddGTDialog";

const GeneralTenantCase = lazy(() => import("./GeneralTenantCase"));

const GeneralTenant = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  // The "Fall anlegen" button lives in the top bar, which cannot render
  // the dialog itself - it needs the CaseProvider below. It signals us
  // with a query param instead.
  const requested = searchParams.has(NEW_CASE_PARAM);
  useEffect(() => {
    if (!requested) return;
    setDialogOpen(true);
    // Consume the param so a reload or back-navigation does not reopen it.
    const next = new URLSearchParams(searchParams);
    next.delete(NEW_CASE_PARAM);
    setSearchParams(next, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requested]);

  return (
    <CaseProvider caseMutation={MUTATION_UPDATE_GT_CASE}>
      {dialogOpen && (
        <AddGTDialog handleCloseDialog={() => setDialogOpen(false)} />
      )}
      <Tool
        caseQuery={QUERY_GET_GT_CASE}
        allCasesQuery={QUERY_GET_ALL_GT_CASES}
        deleteMutation={MUTATION_DELETE_GT_CASE}
        partitionKey="D"
      >
        <GeneralTenantCase />
      </Tool>
    </CaseProvider>
  );
};

export default GeneralTenant;
